"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _StagedObject = _interopRequireDefault(require("redux-less/StagedObject"));

var _entitiesSelectors = require("settings-ui-modules/marketing/modules/esp-sync/selectors/entitiesSelectors");

var _stagedSelectors = require("settings-ui-modules/marketing/modules/esp-sync/selectors/stagedSelectors");

var _constants = require("settings-ui-sdk/EspSync/constants");

var properties = [_constants.ESP_API_KEY, _constants.ESP_TYPE];

var _default = new _StagedObject.default({
  domainSelector: _entitiesSelectors.getEspSync,
  stagedSelector: _stagedSelectors.getUpdateEspSync,
  namespace: 'esp-sync',
  objectType: _constants.ESP_SYNC,
  properties: properties
});

exports.default = _default;
module.exports = exports.default;